import { Box, Divider, Link } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { PendingRequests } from '../../../../ui/components/PendingRequests';
import { ShiftRemainingTime } from '../../../../ui/components/ShiftRemainingTime';
import { Slots } from '../../../../ui/components/Slots';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { ShiftDetails } from '../../shift-details';
export const ShiftContainer = ({ shifts, showPendingRequestsCard, linkToMissionDetails }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: ' center',
            px: 4,
            py: 2,
        } },
        shifts.slice(0, 3).map((shift, index) => {
            var _a;
            return (React.createElement(Box, { key: shift.id },
                index !== 0 && React.createElement(Divider, { sx: { my: 2 } }),
                React.createElement(ShiftDetails, { shiftId: shift.id, "data-test": `shift-details-${index}`, location: 'missions', startTime: shift.columns.startTime, stopTime: shift.columns.stopTime, countyName: shift.columns.countyName, analyticsComponent: React.createElement(React.Fragment, null,
                        React.createElement(Slots, { total: shift.columns.totalParticipantSlots, totalApproved: shift.analytics.totalApprovedParticipants }),
                        showPendingRequestsCard && (React.createElement(PendingRequests, { totalPendingParticipants: (_a = shift.analytics.totalPendingParticipants) !== null && _a !== void 0 ? _a : 0 }))), actionsComponent: React.createElement(ShiftRemainingTime, { startTime: shift.columns.startTime }), noPadding: true })));
        }),
        shifts.length > 3 && (React.createElement(Box, { display: 'flex', flexDirection: 'column', sx: { pt: 2 } },
            React.createElement(Divider, { sx: { mb: 2 } }),
            React.createElement(Link, { component: RouterLink, sx: {
                    cursor: 'pointer',
                    alignSelf: 'center',
                    typography: 'button',
                }, to: linkToMissionDetails }, t('missions.viewMoreShifts'))))));
};
